import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-primary" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "navbar-nav me-auto" }
const _hoisted_6 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Monitor ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "(current)", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Usuarios ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "(current)", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "nav-item dropdown"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Registrar Cliente")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Listado de Clientes")
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 3,
  class: "nav-item dropdown"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Registrar Médico")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Listado de Médicos")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 4,
  class: "nav-item dropdown"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Registrar Reclamo Cobertura")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Registrar Reclamo Copago")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Registrar Reclamo Privado")
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Listado de Reclamos")
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = {
  key: 5,
  class: "nav-item dropdown"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Registrar Lote")
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Listado de Lotes")
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = {
  key: 6,
  class: "nav-item dropdown"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Registrar Prefactura")
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Listado de Prefacturas")
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Registrar Factura")
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Listado de Facturas")
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Registrar Refactura")
const _hoisted_63 = [
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Listado de Refacturas")
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Listado de Notas de Débito")
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Listado de Notas de Crédito")
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = {
  key: 7,
  class: "nav-item"
}
const _hoisted_74 = {
  key: 8,
  class: "nav-item"
}
const _hoisted_75 = {
  key: 9,
  class: "nav-item"
}
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Recibos ")
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "(current)", -1)
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = {
  key: 10,
  class: "nav-item"
}
const _hoisted_80 = /*#__PURE__*/_createTextVNode("C x C ")
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "(current)", -1)
const _hoisted_82 = [
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = {
  key: 11,
  class: "nav-item"
}
const _hoisted_84 = /*#__PURE__*/_createTextVNode("Reporte ")
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "(current)", -1)
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = { class: "d-flex" }
const _hoisted_88 = { class: "navbar-nav me-auto" }
const _hoisted_89 = {
  key: 0,
  class: "nav-item dropdown"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1)
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Cerrar Sesión")
const _hoisted_92 = [
  _hoisted_90,
  _hoisted_91
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "navbar-brand",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push(`/dashboard`))),
        href: "#"
      }, "ADFIR"),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMenu())),
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarColor01",
        "aria-controls": "navbarColor01",
        "aria-expanded": "true",
        "aria-label": "Toggle navigation"
      }, _hoisted_4),
      _createElementVNode("div", {
        class: _normalizeClass([{ show: this.show2 }, "collapse navbar-collapse"]),
        id: "navbarColor01"
      }, [
        _createElementVNode("ul", _hoisted_5, [
          (this.$store.state.user.type == 'Administrador')
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createElementVNode("a", {
                  class: "nav-link active",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$router.push(`/monitor`))),
                  href: "#"
                }, _hoisted_9)
              ]))
            : _createCommentVNode("", true),
          (this.$store.state.user.type == 'Administrador')
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createElementVNode("a", {
                  class: "nav-link active",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (this.$router.push(`/usuarios`))),
                  href: "#"
                }, _hoisted_13)
              ]))
            : _createCommentVNode("", true),
          (
              this.$store.state.user.type == 'Power User' ||
                this.$store.state.user.type == 'Administrador'
            )
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _createElementVNode("a", {
                  class: "nav-link dropdown-toggle",
                  "data-bs-toggle": "dropdown",
                  href: "#",
                  role: "button",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tshowCliente()))
                }, "Clientes"),
                _createElementVNode("div", {
                  class: _normalizeClass([{ show: this.showCliente }, "dropdown-menu"])
                }, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (this.$router.push(`/clientes/new`))),
                    href: "#"
                  }, _hoisted_17),
                  _createElementVNode("a", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (this.$router.push(`/clientes`))),
                    class: "dropdown-item",
                    href: "#"
                  }, _hoisted_20)
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (
              this.$store.state.user.type == 'Power User' ||
                this.$store.state.user.type == 'Administrador'
            )
            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                _createElementVNode("a", {
                  class: "nav-link dropdown-toggle",
                  "data-bs-toggle": "dropdown",
                  href: "#",
                  role: "button",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tshowMedico()))
                }, "Médicos"),
                _createElementVNode("div", {
                  class: _normalizeClass([{ show: this.showMedico }, "dropdown-menu"])
                }, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (this.$router.push(`/medicos/new`))),
                    href: "#"
                  }, _hoisted_24),
                  _createElementVNode("a", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (this.$router.push(`/medicos`))),
                    class: "dropdown-item",
                    href: "#"
                  }, _hoisted_27)
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (
              this.$store.state.user.type == 'Power User' ||
                this.$store.state.user.type == 'Administrador' ||
                this.$store.state.user.type == 'Digitador'
            )
            ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                _createElementVNode("a", {
                  class: "nav-link dropdown-toggle",
                  "data-bs-toggle": "dropdown",
                  href: "#",
                  role: "button",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.tshowReclamo()))
                }, "Reclamos"),
                _createElementVNode("div", {
                  class: _normalizeClass([{ show: this.showReclamo }, "dropdown-menu"])
                }, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (this.$router.push(`/documentosrec/new`))),
                    href: "#"
                  }, _hoisted_31),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (this.$router.push(`/documentosreccop/new`))),
                    href: "#"
                  }, _hoisted_34),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (this.$router.push(`/documentosrecpri/new`))),
                    href: "#"
                  }, _hoisted_37),
                  _createElementVNode("a", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (this.$router.push(`/documentosrec`))),
                    class: "dropdown-item",
                    href: "#"
                  }, _hoisted_40)
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (
              this.$store.state.user.type == 'Power User' ||
                this.$store.state.user.type == 'Administrador' ||
                this.$store.state.user.type == 'Digitador'
            )
            ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                _createElementVNode("a", {
                  class: "nav-link dropdown-toggle",
                  "data-bs-toggle": "dropdown",
                  href: "#",
                  role: "button",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.tshowLote()))
                }, "Lotes"),
                _createElementVNode("div", {
                  class: _normalizeClass([{ show: this.showLote }, "dropdown-menu"])
                }, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (this.$router.push(`/documentoslot/new`))),
                    href: "#"
                  }, _hoisted_44),
                  _createElementVNode("a", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (this.$router.push(`/documentoslot`))),
                    class: "dropdown-item",
                    href: "#"
                  }, _hoisted_47)
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (
              this.$store.state.user.type == 'Power User' ||
                this.$store.state.user.type == 'Administrador' ||
                this.$store.state.user.type == 'Digitador'
            )
            ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                _createElementVNode("a", {
                  class: "nav-link dropdown-toggle",
                  "data-bs-toggle": "dropdown",
                  href: "#",
                  role: "button",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.tshowPrefactura()))
                }, "Facturación"),
                _createElementVNode("div", {
                  class: _normalizeClass([{ show: this.showPrefactura }, "dropdown-menu"])
                }, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (this.$router.push(`/documentos/new`))),
                    href: "#"
                  }, _hoisted_51),
                  _createElementVNode("a", {
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (this.$router.push(`/documentos`))),
                    class: "dropdown-item",
                    href: "#"
                  }, _hoisted_54),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (this.$router.push(`/documentosfac/new`))),
                    href: "#"
                  }, _hoisted_57),
                  _createElementVNode("a", {
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (this.$router.push(`/documentosfac`))),
                    class: "dropdown-item",
                    href: "#"
                  }, _hoisted_60),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (this.$router.push(`/documentosrefac/new`))),
                    href: "#"
                  }, _hoisted_63),
                  _createElementVNode("a", {
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (this.$router.push(`/documentosrefac`))),
                    class: "dropdown-item",
                    href: "#"
                  }, _hoisted_66),
                  _createElementVNode("a", {
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (this.$router.push(`/documentosnd`))),
                    class: "dropdown-item",
                    href: "#"
                  }, _hoisted_69),
                  _createElementVNode("a", {
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (this.$router.push(`/documentosnc`))),
                    class: "dropdown-item",
                    href: "#"
                  }, _hoisted_72)
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (this.$store.state.user.type == 'Administrador')
            ? (_openBlock(), _createElementBlock("li", _hoisted_73))
            : _createCommentVNode("", true),
          (this.$store.state.user.type == 'Administrador')
            ? (_openBlock(), _createElementBlock("li", _hoisted_74))
            : _createCommentVNode("", true),
          (this.$store.state.user.type == 'Administrador')
            ? (_openBlock(), _createElementBlock("li", _hoisted_75, [
                _createElementVNode("a", {
                  class: "nav-link active",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (this.$router.push(`/documentosre`))),
                  href: "#"
                }, _hoisted_78)
              ]))
            : _createCommentVNode("", true),
          (this.$store.state.user.type == 'Administrador')
            ? (_openBlock(), _createElementBlock("li", _hoisted_79, [
                _createElementVNode("a", {
                  class: "nav-link active",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (this.$router.push(`/cuentasporcobrar`))),
                  href: "#"
                }, _hoisted_82)
              ]))
            : _createCommentVNode("", true),
          (this.$store.state.user.type == 'Administrador')
            ? (_openBlock(), _createElementBlock("li", _hoisted_83, [
                _createElementVNode("a", {
                  class: "nav-link active",
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (this.$router.push(`/documentosfacint`))),
                  href: "#"
                }, _hoisted_86)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("ul", _hoisted_88, [
            (
                this.$store.state.user.type == 'Power User' ||
                  this.$store.state.user.type == 'Administrador' ||
                  this.$store.state.user.type == 'Digitador' ||
                  this.$store.state.user.type == 'Médico'
              )
              ? (_openBlock(), _createElementBlock("li", _hoisted_89, [
                  _createElementVNode("a", {
                    class: "nav-link dropdown-toggle blue",
                    "data-bs-toggle": "dropdown",
                    href: "#",
                    role: "button",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showName2()))
                  }, _toDisplayString(this.$store.state.user.usuario), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass([{ show: this.showName }, "dropdown-menu"])
                  }, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.salir())),
                      href: "#"
                    }, _hoisted_92)
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ])
  ]))
}